export default __webpack_public_path__ + "static/media/user-video.60155c46.svg";